export enum PeriodTypeEnums {
  WEEKLY = 1,
  PAY_PERIOD = 2,
}
